<template lang="pug">
  #mobile-footer
    RouterLink.mf-nav-wrap(:to="{name: 'likesIndex'}")
      icon(data="~@/assets/svg/heart.svg" width="2.4rem" height="2.4rem" :fill="false")
      span Likes

    RouterLink.mf-nav-wrap(:to="{name: 'peopleIndex'}")
      icon(data="~@/assets/svg/users.svg" width="2.4rem" height="2.4rem" :fill="false")
      span People

    RouterLink.mf-nav-wrap(:to="{name: 'visitorsIndex'}")
      icon(data="~@/assets/svg/eye.svg" width="2.4rem" height="2.4rem" :fill="false")
      span Visitors
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {},
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
